import React from 'react';
import { useSelector } from 'react-redux';
import { profileNav4 } from '../../../../config';
import { FMessage } from '../../../../hoc/IntlComponents';
import { NavLink as Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import Card from '../../../../components/Card/Card';

const ProfileNav = ({ history }) => {
  const documents = useSelector(state => state.webmaster.profile.documents);

  const filteredNav = profileNav4.filter(({ id }) => {
    if (id === 'contracts') {
      return !!documents;
    }
    return true;
  });
  return (
    <Card className="profile-navigation">
      {filteredNav.map(({ id, translated, path }) => (
        <Card.Body
          key={id}
          className={
            path === history.location.pathname
              ? 'no-padding px-3 py-2 active'
              : 'no-padding px-3 py-2'
          }
        >
          <NavLink to={path} tag={Link}>
            <FMessage id={translated + '.theme_4'} />
          </NavLink>
        </Card.Body>
      ))}
    </Card>
  );
};

export default withRouter(ProfileNav);
